import React from "react";
import "../assets/css/App.css";
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink
} from "reactstrap";
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import {
   Breadcrumb,
} from 'antd';


class Public extends React.Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false,
      navColor:{
        backgroundColor:"rgb(0,21,41)"
      },
      brandStyle:{
        fontSize: 40, fontWeight:"bold", color:"white",textAlign: "center"
      },
      navLinkStyle:{
        fontSize: 24, fontWeight:"bold", color:"white"
      }

    };
  }
  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }
  render() {
    return (
      <div>
        <Navbar style={this.state.navColor} light expand="xl">
          <NavbarBrand href="/" style={this.state.brandStyle} className="navbrand">CIITOOL</NavbarBrand>
          <NavbarToggler onClick={this.toggle} style={{backgroundColor:"rgb(220,220,200)"}} />
          <Collapse isOpen={this.state.isOpen} navbar>
            <Nav className="ml-auto navbox" navbar>
              <NavItem className="navitem">
                <NavLink>
                  <Link to="/mifa" style={this.state.navLinkStyle}>Medical Image Feature Atlas</Link>
                </NavLink>
              </NavItem>
              <NavItem >
                <NavLink className="navitem">
                <Link to="/hcc" style={this.state.navLinkStyle}>Hepatocellular Carcinoma</Link>
                </NavLink>
              </NavItem>
              <NavItem >
                <NavLink className="navitem">
                <Link to="/bicomb" style={this.state.navLinkStyle}>Bicomb</Link>
                </NavLink>
              </NavItem>
              <NavItem >
                <NavLink className="navitem">
                <Link to="/clarityICI" style={this.state.navLinkStyle}>CLARITY-ICI Matrix</Link>
                </NavLink>
              </NavItem>
              <NavItem className="navitem">
                <NavLink>
                <Link to="/continue" style={this.state.navLinkStyle}>Contact Us</Link>
                </NavLink>
              </NavItem>
            </Nav>
          </Collapse>
        </Navbar>
        <Breadcrumb style={{ padding: '16px 50px' }}>
                <Breadcrumb.Item><Link to="/">Home</Link></Breadcrumb.Item>
                <Breadcrumb.Item><Link to="/Chinese">Chinese</Link></Breadcrumb.Item>
                <Breadcrumb.Item><Link to="/contact">Contact</Link></Breadcrumb.Item>
                </Breadcrumb>
      </div>
    );
  }
}
export default Public;
